import { autoinject, transient } from "aurelia-framework";
import { ValidationController, ValidationControllerFactory, ValidationRules } from "aurelia-validation";
import { CustomValidationRenderer } from "../../../../../../client-validation-system/custom-validation-renderer";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightShipOnboardingQuestionCommentService } from "../../../../../../services/rightship-onboarding/rightship-onboarding-question-comment.service";
import { FormMetaItem } from "../../../../../components/editors/form-editor/form-meta-config";
import { Guid } from "../../../../../../utilities/guid";

@autoinject()
@transient()
export class DialogAddMessage {

    public isEditing: boolean;
    public validator: ValidationController;
    public questionGuid: Guid;
    public question: string;
    public message: string = "";

    public constructor(private dialogClientService: DialogClientService, validationControllerFactory: ValidationControllerFactory,
        public questionCommentsService: RightShipOnboardingQuestionCommentService)  {        
        this.validator = validationControllerFactory.createForCurrentScope();
        this.validator.addRenderer(new CustomValidationRenderer())
    }

    activate(model: { item: FormMetaItem}) {
        this.questionGuid = model.item.guid;
        this.message = this.questionCommentsService.getQuestionComment(this.questionGuid);
        this.question = Object.keys(this.questionCommentsService?.questionTexts).indexOf(model?.item?.guid) > -1 ?
            (this.questionCommentsService?.questionTexts[model.item.guid] ?? model.item.question)
            : model.item.question;
        this.isEditing = this.message && this.message?.trim() != "";
    }

    attached() {
        this.validator.addObject(this, this.getRules());
    }

    private getRules() {
        const rules = ValidationRules
            .ensure<DialogAddMessage, any>(x => x.message)
            .required()
            .withMessage("Message is required")
            .on(this);

        return rules.rules;
    }

    public cancel() {
        this.dialogClientService.hide(true);
    }

    public add() {
        return new Promise<void>((resolve, reject) => {
            this.validator.validate().then(x => {
                if (x.valid) {
                    this.questionCommentsService.setQuestionComment(this.questionGuid, this.message, this.question);
                    this.dialogClientService.hide(true);
                    resolve();
                }
                else 
                {
                    reject();
                }
            });
        });
    }
}